import { toast } from 'react-toastify';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { FailToastContainer } from 'components/Toast/ToastContainer';
import { HTTPStatusCode } from 'config/const';
import { IAction, IPOSCategories } from 'types';
import { formatErrorMessages } from 'utils/errors';
import * as API from '../../../api';
import * as Actions from './actions';
import { IPOSCategoriesPayload, POSCategories } from './types';

export function* getPOSCategories({ payload }: IAction<POSCategories, IPOSCategoriesPayload>): any {
  try {
    const { siteId } = payload;
    const response: ApiResponse<IPOSCategories> = yield call(API.Integrations.showPOSCategories, siteId);

    yield put(Actions.getPosCategoriesSuccess(response.body));
  } catch (error: any) {
    const isIntegrationNotFoundError = error.statusCode === HTTPStatusCode.NOT_FOUND && error.body?.errors?.[0].param === 'integrations' && error.body?.errors?.[0].msg === 'not found';

    if (isIntegrationNotFoundError) {
      yield call(toast, FailToastContainer({ message: 'This site does not have a point of sale integration. Please contact support to enable the integration.' }));
    }

    const formattedError = formatErrorMessages({
      errors: error.body?.errors,
      statusCode: error.statusCode,
    });

    yield put(Actions.getPosCategoriesError(formattedError, !isIntegrationNotFoundError));
  }
}

export function* watchGetPOSCategories() {
  yield takeEvery(POSCategories.GET_POS_CATEGORIES_REQUEST, getPOSCategories);
}

function* posCategoriesSagas() {
  yield all([fork(watchGetPOSCategories)]);
}
export { posCategoriesSagas };
